export const getUserChannelIDs = (userChannelList) =>
    userChannelList?.map(({ channelID }) => channelID);
export const isUserChannel = (userChannelList = [], channelID) => userChannelList?.length && channelID ? getUserChannelIDs(userChannelList)?.includes(channelID) : false;